import moment from 'moment';
const DateFormat = 'YYYY-MM-DD';
const EarliestStartDate = '2000-01-01';
export const toPeriodDate = (date) => moment.utc(date).format(DateFormat);
export const lastCalendarYear = () => {
    const year = moment().year() - 1;
    return { startDate: `${year}-01-01`, endDate: `${year}-12-31` };
};
export const isPreviewOfPeriod = (preview, period) => !!preview &&
    moment.utc(preview.startDate).format(DateFormat) === period.startDate &&
    moment.utc(preview.endDate).format(DateFormat) === period.endDate;
// Durations are per occurrence, so a period shorter than a year misses or cuts occurrences of less frequent tasks.
export const isShorterThanYear = (period) => moment
    .utc(period.endDate)
    .add(1, 'day')
    .isBefore(moment.utc(period.startDate).add(1, 'year'));
// Same limits as the backend: from 2000, until today, at most three years.
export const isValidPeriod = (period) => {
    const start = moment.utc(period.startDate);
    const end = moment.utc(period.endDate);
    return (!start.isBefore(moment.utc(EarliestStartDate)) &&
        !end.isBefore(start) &&
        !end.isAfter(moment.utc().startOf('day')) &&
        end.isBefore(start.clone().add(3, 'years')));
};
// Also keeps a half-typed year such as "2" from counting as a date, which would move the focus to the end date.
export const isOutsidePeriodRange = (day) => day.isBefore(moment(EarliestStartDate), 'day') || day.isAfter(moment(), 'day');
export const toPickedDates = (period) => ({
    startDate: moment.utc(period.startDate),
    endDate: moment.utc(period.endDate),
});
